import React from 'react'

const MaintenancePage: React.FC = () => {
  return (
    <div
      style={{
        fontFamily:
          "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        background: 'linear-gradient(135deg, #0f4f99 0%, #0a3568 100%)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        color: 'white',
      }}
    >
      <div
        style={{
          maxWidth: '600px',
          width: '100%',
          background: '#ffffff',
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          padding: '60px 40px',
          textAlign: 'center',
          animation: 'fadeInUp 0.8s ease-out',
        }}
      >
        <style>
          {`
            @keyframes fadeInUp {
              from { opacity: 0; transform: translateY(30px); }
              to { opacity: 1; transform: translateY(0); }
            }
            @keyframes pulse {
              0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(15, 79, 153, 0.4); }
              50% { transform: scale(1.05); box-shadow: 0 0 0 20px rgba(15, 79, 153, 0); }
            }
            @keyframes bounce {
              0%, 80%, 100% { transform: scale(0); opacity: 0.5; }
              40% { transform: scale(1); opacity: 1; }
            }
          `}
        </style>

        <div style={{ marginBottom: '40px' }}>
          <img
            src='https://credibila-assets.s3.ap-south-1.amazonaws.com/images/credibila_logo.png'
            alt='Credibila Logo'
            style={{ maxWidth: '200px', height: 'auto' }}
          />
        </div>

        <div style={{ marginBottom: '32px' }}>
          <div
            style={{
              width: '120px',
              height: '120px',
              margin: '0 auto',
              background: 'linear-gradient(135deg, #0f4f99 0%, #0a3568 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'pulse 2s ease-in-out infinite',
            }}
          >
            <svg viewBox='0 0 24 24' width='60' height='60' fill='white'>
              <path d='M21.71 11.29l-9-9a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 13h1v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7h1a1 1 0 0 0 .92-.62 1 1 0 0 0-.21-1.09zM16 20H8v-6h8zm2-8h-2.59l-5.7-5.71L12 4l8 8z' />
              <path d='M9 13h2v2H9zm4 0h2v2h-2z' />
            </svg>
          </div>
        </div>

        <h1
          style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#0f4f99',
            marginBottom: '16px',
            letterSpacing: '-0.025em',
          }}
        >
          We&apos;re Currently Under Maintenance
        </h1>

        <p
          style={{
            fontSize: '18px',
            fontWeight: '500',
            color: '#545a5e',
            marginBottom: '24px',
          }}
        >
          Scheduled System Upgrade in Progress
        </p>

        <p
          style={{
            fontSize: '16px',
            fontWeight: '400',
            color: '#545a5e',
            lineHeight: '1.6',
            marginBottom: '40px',
          }}
        >
          We&apos;re performing scheduled maintenance to improve your experience. Our platform is
          temporarily unavailable while we work on important updates and enhancements.
        </p>

        <div
          style={{
            background: '#f7f7f7',
            borderLeft: '4px solid #caa566',
            padding: '20px',
            borderRadius: '8px',
            textAlign: 'left',
            marginBottom: '32px',
          }}
        >
          <p style={{ fontSize: '14px', color: '#545a5e', lineHeight: '1.5', margin: '0' }}>
            <strong style={{ color: '#0f4f99', fontWeight: '600' }}>What&apos;s happening?</strong>
            <br />
            We&apos;re deploying new features and improvements to serve you better. This maintenance
            is essential to ensure the continued security, performance, and reliability of our
            platform.
          </p>
        </div>

        <div
          style={{
            background: '#f7f7f7',
            borderLeft: '4px solid #caa566',
            padding: '20px',
            borderRadius: '8px',
            textAlign: 'left',
            marginBottom: '32px',
          }}
        >
          <p style={{ fontSize: '14px', color: '#545a5e', lineHeight: '1.5', margin: '0' }}>
            <strong style={{ color: '#0f4f99', fontWeight: '600' }}>When will we be back?</strong>
            <br />
            We&apos;re working as quickly as possible to complete this maintenance. The platform
            should be back online shortly. Please check back in a few minutes.
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '8px',
            marginBottom: '40px',
          }}
        >
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: '#caa566',
                borderRadius: '50%',
                animation: 'bounce 1.4s ease-in-out infinite',
                animationDelay: `${i * 0.2}s`,
              }}
            />
          ))}
        </div>

        <div
          style={{
            marginTop: '40px',
            paddingTop: '32px',
            borderTop: '1px solid #e2e2e2',
          }}
        >
          <p
            style={{
              fontSize: '14px',
              color: '#545a5e',
              marginBottom: '12px',
            }}
          >
            If you have urgent questions or concerns, please contact us:
          </p>
          <a
            href='mailto:support@credibila.com'
            style={{
              color: '#0f4f99',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'color 0.3s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = '#0a3568')}
            onMouseOut={(e) => (e.currentTarget.style.color = '#0f4f99')}
          >
            support@credibila.com
          </a>
        </div>
      </div>
    </div>
  )
}

export default MaintenancePage
